import React from "react";
import Modal from "react-bootstrap/Modal";
import UserProfessionalRoleSelection from "../components/UserProfessionalRoleSelection";

const UserProfessionalRoleSelectionModal = ({
  visible,
  close,
  user,
  updateUser,
}) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          <h1 className={"text-axis-offblack icon-text-wrapper"}>
            Select User Role
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UserProfessionalRoleSelection
          user={user}
          onComplete={(u) => {
            if (updateUser !== null && updateUser !== undefined) updateUser(u);
            close();
          }}
          close={close}
        />
      </Modal.Body>
    </Modal>
  );
};

export default UserProfessionalRoleSelectionModal;
